import { ScField } from '@app/components/Base/ScFinalForm';
import TextField from '@app/components/Layout/Shares/FormHelpers/TextField';
import ScDivider from '@app/components/UI/ScDivider';

const ReportInfoTab = () => (
    <>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="if_reporttitle"
                        component={TextField}
                        label="Tiêu đề mẫu in"
                        className="form-control"
                        requiredChar
                    />
                </div>
            </div>
        </div>
        <ScDivider
            variant="dashed"
            titlePlacement="left"
            style={{ borderColor: '#7cb305' }}
        >
            THÔNG TIN KÝ TÊN
        </ScDivider>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_logo_customer_title"
                        component={TextField}
                        label="Tiêu đề khách hàng"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_customertitle"
                        component={TextField}
                        label="Tiêu đề người mua hàng"
                        className="form-control"
                        requiredChar
                    />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_logo_accountant_title"
                        component={TextField}
                        label="Tiêu đề kế toán"
                        className="form-control"
                    />
                </div>
            </div>
        </div>

        {/* Vận chuyển */}
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_logo_shipper_title"
                        component={TextField}
                        label="Tiêu đề người giao hàng"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_shipper_name"
                        component={TextField}
                        label="Tên người giao hàng"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
    </>
);

export default ReportInfoTab;
